module.exports = __webpack_public_path__ + "img/25-compass-nav.d6fa23da.png";